
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-facets{
  font-family:var(--ff-dmsans);
  display:flex;
  flex-direction:column;
}

  .se-facets [slot='heading']{
    margin:0;
  }

  .se-facets__title{
    border-bottom:solid 1px var(--gray-800);
    text-transform:uppercase;
    padding:0.75rem 1rem;
    margin:0;
  }

  .se-facets .js-form-type-checkbox{
    padding-top:var(--spacing-3);
  }

  .se-facets .js-form-type-checkbox label:hover{
        cursor:pointer;
      }

  .se-facets .hidden{
    display:none;
    position:absolute !important;
    overflow:hidden;
    clip:rect(1px, 1px, 1px, 1px);
    width:1px;
    height:1px;
    word-wrap:normal;
  }

  .se-facets .toggle-btn{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    gap:var(--spacing-4);
    color:var(--brand-primary-2);
    margin-top:var(--spacing-4);
    -webkit-appearance:none;
    background:transparent;
    border:0;
    font-size:var(--fs-sm);
    font-weight:(--fw-bold);
  }

  .se-facets .toggle-btn:hover{
      outline:none;
      cursor:pointer;
      text-decoration:underline;
    }

  .se-facets .accordion-content mobile{
    border:0;
    padding-top:0;
  }
`;